import React from 'react';
import { Box, Typography } from '@material-ui/core';
import InputForm from '../../InputForm/InputForm';
import InputFormDescription from '../../InputFormDescription/InputFormDescription';
import ImportImage from '../../ImportImage/ImportImage';
import { IEditForm } from '../../../types/interfaces/IEditForm';
import useStyles from './InputFields.styles';
import ReadField from '../../ReadField/ReadField';
import CheckboxGrid from '../../CheckboxGrid/CheckboxGrid';
import CreatePasswordField from '../../CreatePasswordField/CreatePasswordField';
import SwitchInput from '../../SwitchInput/SwitchInput';
import CustomSelect from '../../CustomSelect/CustomSelect';
import CodesGenerationField from '../../CodesGenerationField/CodesGenerationField';

interface IItemProps {
  data: IEditForm[][];
}

const formTypeToComponent = {
  image: (form: IEditForm) => <ImportImage key={form.fieldName} {...form} />,
  input: (form: IEditForm) => <InputForm key={form.fieldName} {...form} />,
  description: (form: IEditForm) => <InputFormDescription key={form.fieldName} {...form} />,
  checkboxGrid: (form: IEditForm) => <CheckboxGrid key={form.fieldName} {...form} />,
  read: (form: IEditForm) => <ReadField key={form.fieldName} {...form} />,
  createPassword: (form: IEditForm) => <CreatePasswordField key={form.fieldName} {...form} />,
  switch: (form: IEditForm) => <SwitchInput key={form.fieldName} {...form} />,
  title: (form: IEditForm) => <Typography key={form.fieldName} variant="h5" children={form.label} />,
  select: (form: IEditForm) => <CustomSelect key={form.fieldName} {...form} />,
  codesGeneration: (form: IEditForm) => <CodesGenerationField key={form.fieldName} {...form} />,
};

const InputFields: React.FC<IItemProps> = ({ data }) => {
  const styles = useStyles();

  return (
    <>
      {data.map((column, index) => (
        <Box key={index} className={styles.column}>
          {column.map((form) =>
            form.hidden ? null : (
              <Box className={styles.row} key={form.fieldName} marginY={1}>
                {formTypeToComponent[form.type](form)}
              </Box>
            ),
          )}
        </Box>
      ))}
    </>
  );
};

export default InputFields;
